import PropTypes from 'prop-types';
import addressShape from 'react/shared/shapes/address_shape';
import shippingDestinationShape from 'react/signups/card/shapes/ShippingDestination.js';

const shippingDataShape = PropTypes.shape({
  shippingDestination: shippingDestinationShape,
  otherAddress: addressShape,
});

export default shippingDataShape;
